// extracted by mini-css-extract-plugin
export default {"card":"CategoryItem_card__wZU2v"};